const typography = {
  weight: {
    thin: '300',
    extraBold: '700',
  },
};

export { typography };
